<template>
  <div class="checkbox-area">
    <label class="checkbox">
      <input
        :id="id"
        type="checkbox"
        :name="id"
        :checked="checked"
        :value="value"
        @change="onchange" />
      <span class="checkbox-custom"></span>
    </label>
    <label class="checkbox-label" for="scales">
      {{ label }}
    </label>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    id: {
      type: Number,
      required: true,
    },
    value: {
      type: [String, Number, Object],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    checked: {
      type: Boolean,
      required: false,
      default: false,
    },
    onchange: {
      type: Function,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-area {
  display: flex;
  align-items: center;
  padding: 8px 0;

  & .checkbox {
    display: block;
    position: relative;
    cursor: pointer;
    font-size: 22px;
    line-height: 16px;
    height: 16px;
    width: 16px;
    clear: both;

    & .checkbox-custom {
      position: absolute;
      top: 0;
      left: 0;
      height: 16px;
      width: 16px;
      background-color: transparent;
      border-radius: 4px;
      transition: all 0.3s ease-out;
      border: 1px solid #000000;

      &:after {
        position: absolute;
        content: "";
        left: 8px;
        top: 8px;
        height: 0px;
        width: 0px;
        border: #000000;
        border-width: 0 3px 3px 0;
        transform: rotate(0deg) scale(0);
        opacity: 1;
      }
    }

    & input[type="checkbox"] {
      position: absolute;
      opacity: 0;
      cursor: pointer;
    }

    & input:checked ~ .checkbox-custom {
      background-color: #0073ab;
      border-radius: 5px;
      transform: rotate(0deg) scale(1);
      opacity: 1;
      border: 1px solid #000000;
      &:after {
        transform: rotate(45deg) scale(1);
        opacity: 1;
        left: 5px;
        top: 2px;
        width: 4px;
        height: 8px;
        border: solid #ffffff;
        border-width: 0 2px 2px 0;
        background-color: transparent;
        border-radius: 0;
      }
    }
  }

  & label {
    font-family: "Maersk Headline";
    font-size: 14px;
    padding-left: 6px;
    color: #000000;
    text-align: left;
  }
}
</style>
